import { ReactNode } from 'react';

import ContentBody from './ContentBody';
import ContentHeader from './ContentHeader';

interface Props {
  backTo?: string;
  badge?: ReactNode;
  children: ReactNode;
  rightHeader?: ReactNode;
  title: string;
}

const Content = ({ backTo, badge, children, rightHeader, title }: Props) => {
  return (
    <>
      <ContentHeader
        backTo={backTo}
        badge={badge}
        rightHeader={rightHeader}
        title={title}
      />
      <ContentBody>{children}</ContentBody>
    </>
  );
};

Content.displayName = 'Content';

export default Content;
